type PushData = Record<string, string | boolean | undefined>;
type PushNotification = { title?: string; body?: string };
type PushPayload = { data?: PushData; notification?: PushNotification };

export function parsePushPayload(payload: unknown) {
  const raw = (payload ?? {}) as PushPayload;
  const data = raw.data ?? {};
  const notification = raw.notification ?? {};

  const urgentRaw = data.urgent;
  const urgent = urgentRaw === 'true' || urgentRaw === true;
  const parsedExpiresAt = Number(data.expiresAt);
  const expiresAt = Number.isFinite(parsedExpiresAt) && parsedExpiresAt > 0
    ? parsedExpiresAt
    : undefined;

  const ticketId = data.ticketId ? String(data.ticketId) : undefined;
  const houseId = data.houseId ? String(data.houseId) : undefined;
  const target = data.target ? String(data.target) : undefined;
  const runId = data.runId ? String(data.runId) : undefined;
  const signalCode = data.signalCode ? String(data.signalCode) : undefined;
  const meta = (ticketId || houseId || target || runId || signalCode)
    ? {
        ...(ticketId ? { ticketId } : {}),
        ...(houseId ? { houseId } : {}),
        ...(target ? { target } : {}),
        ...(runId ? { runId } : {}),
        ...(signalCode ? { signalCode, signalCodes: [signalCode] } : {}),
      }
    : undefined;

  const id = data.id ? String(data.id) : (data.tag ? String(data.tag) : undefined);

  return {
    ...(id ? { id } : {}),
    cat: (data.cat as string) ?? 'system',
    sev: (data.sev as string) ?? 'info',
    urgent,
    title: notification.title ?? (data.title as string) ?? 'Alea TUI',
    body: notification.body ?? (data.body as string) ?? '',
    ...(expiresAt ? { expiresAt } : {}),
    ...(meta ? { meta } : {}),
  };
}
